import { Link } from 'react-router-dom';
import { categories } from '@/mocks/travelData';

const categoryImages: Record<string, string> = {
  'tropical-islands': 'https://readdy.ai/api/search-image?query=Tropical%20island%20paradise%20with%20crystal%20clear%20turquoise%20water%20white%20sandy%20beach%20palm%20trees%20luxury%20resort%20aerial%20view%20soft%20warm%20sunlight&width=800&height=500&seq=cat-tropical-home&orientation=landscape',
  'ancient-capitals': 'https://readdy.ai/api/search-image?query=Ancient%20Asian%20temple%20complex%20with%20traditional%20architecture%20golden%20roof%20intricate%20carvings%20misty%20morning%20cultural%20heritage%20serene%20atmosphere&width=800&height=500&seq=cat-ancient-home&orientation=landscape',
  'mountain-secrets': 'https://readdy.ai/api/search-image?query=Majestic%20mountain%20range%20with%20terraced%20rice%20fields%20misty%20valleys%20traditional%20villages%20golden%20sunrise%20dramatic%20clouds%20lush%20green%20landscape&width=800&height=500&seq=cat-mountain-home&orientation=landscape',
  'urban-romance': 'https://readdy.ai/api/search-image?query=Modern%20Asian%20city%20skyline%20at%20night%20with%20neon%20lights%20bustling%20street%20food%20market%20vibrant%20energy%20contemporary%20architecture%20warm%20glowing%20lanterns&width=800&height=500&seq=cat-urban-home&orientation=landscape',
  'wellness-retreat': 'https://readdy.ai/api/search-image?query=Luxury%20spa%20resort%20with%20natural%20hot%20springs%20surrounded%20by%20bamboo%20forest%20zen%20garden%20calm%20meditation%20soft%20steam%20rising%20traditional%20Asian%20architecture&width=800&height=500&seq=cat-wellness-home&orientation=landscape',
  'culinary-journey': 'https://readdy.ai/api/search-image?query=Vibrant%20Asian%20night%20food%20market%20with%20steaming%20street%20food%20stalls%20colorful%20lanterns%20fresh%20ingredients%20aromatic%20spices%20local%20chefs%20cooking%20warm%20lighting&width=800&height=500&seq=cat-culinary-home&orientation=landscape',
};

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-2">
            探索旅行主题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            按旅行类型发现适合您的亚洲目的地
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-3 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-medium text-foreground-800 whitespace-nowrap">
                {cat.name}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}